import mutations from './logMutations';
import actions from './logActions';
import getters from './logGetters';

const state = {
  /* failLog state * */
  failLogList: [],
  /* 실패 목록페이징 처리를 위한 값 * */
  currentPage: 1,
  pageSize: 10,
  pageUnit: 10,
  records: 0,
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/rem/log/logStore.js